<template>
    <div>
        <page-header title="لیست سفارشات"></page-header>

        <search-filter :filters="filters" @search="search"></search-filter>

        <table-with-pagination v-if="orders"
                               :items="orders"
                               :headers="headers"
                               :default-page="parseInt($route.query.page ?? '1')"
                               @fetchPage="getOrders"
                               @delete="deleteOrder"
                               @statusChanged="statusChanged"
                               @showDetails="showDetails"
                               @downloadInvoice="downloadInvoice"
                               @uploadInvoice="openUploadInvoiceDialog"
                               @makeCustomerNote="openWriteCustomerNoteDialog"
                               @makeAdminNote="openWriteAdminNoteDialog"
                               :actions="actions"
        ></table-with-pagination>

        <v-dialog v-model="uploadInvoiceDialog" width="600px" v-if="selectedOrder">
            <v-card color="#393E46">
                <v-card-title>آپلود صورتحساب</v-card-title>
                <v-card-text>
                    <file-uploader @fileUploaded="filesReady" label="فایل خود را انتخاب کنید"></file-uploader>
                </v-card-text>
                <v-card-actions class="px-6 pb-6">
                    <div class="form-actions" style="width: 100%">
                        <v-btn class="btn-secondary" outlined @click="closeUploadInvoiceDialog">
                            انصراف
                        </v-btn>
                        <v-btn class="btn-primary" depressed @click="uploadInvoice">
                            بله
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="writeCustomerNoteDialog" width="600px" v-if="selectedOrder">
            <v-card color="#393E46">
                <v-card-title>افزودن یادداشت برای مشتری</v-card-title>
                <v-card-text>
                    <v-textarea
                            v-model="customerNote" color="#00ADB5" outlined
                    ></v-textarea>
                </v-card-text>
                <v-card-actions class="px-6 pb-6">
                    <div class="form-actions" style="width: 100%">
                        <v-btn class="btn-secondary" outlined @click="closeWriteCustomerNoteDialog">
                            انصراف
                        </v-btn>
                        <v-btn class="btn-primary" depressed @click="updateCustomerNote">
                            ثبت
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="writeAdminNoteDialog" width="600px" v-if="selectedOrder">
            <v-card color="#393E46">
                <v-card-title>توضیحات پنل</v-card-title>
                <v-card-text>
                    <v-textarea
                            v-model="adminNote" color="#00ADB5" outlined
                    ></v-textarea>
                </v-card-text>
                <v-card-actions class="px-6 pb-6">
                    <div class="form-actions" style="width: 100%">
                        <v-btn class="btn-secondary" outlined @click="closeWriteAdminNoteDialog">
                            انصراف
                        </v-btn>
                        <v-btn class="btn-primary" depressed @click="updateAdminNote">
                            ثبت
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog width="500" v-model="detailsDialog">
            <v-card color="#393E46" v-if="selectedOrder">
                <v-card-text class="pa-4">
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                    class="background-table" align="center" :headers="detailTableHeaders"
                                    :items="selectedOrder.details" :items-per-page="100" disable-sort
                                    hide-default-footer>

                                <template v-slot:[`item.product`]="{ item }">
                                    <h5>{{ item.product.id }} | {{ item.product.fa_name }}</h5>
                                    <img width="100px" :src="item.product.image_url">
                                </template>
                                <template v-slot:[`item.article_number`]="{ item }">
                                    <h5>{{ item.product.article_number }}</h5>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import TableWithPagination from "@/components/General/TableWithPagination";
import SearchFilter from "@/components/General/SearchFilter.vue";
import FileUploader from "@/components/File/FileUploader.vue";

export default {
    name: "OrderList",

    components: {FileUploader, SearchFilter, TableWithPagination, PageHeader},

    data() {
        return {
            writeCustomerNoteDialog: false,
            writeAdminNoteDialog: false,
            customerNote: null,
            adminNote: null,
            uploadInvoiceDialog: false,
            selectedOrder: null,
            invoiceFile: null,

            detailsDialog: false,

            headers: [
                {text: 'شناسه', value: 'id', align: 'center'},
                {text: 'مشتری', value: 'customer', align: 'center'},
                {text: 'وضعیت', value: 'status_name', align: 'center'},
                {text: 'محصولات', value: 'details', align: 'center'},
                {text: 'یادداشت پنل', value: 'admin_note', align: 'center'},
                {text: 'صورتحساب', value: 'invoice_url', align: 'center'},
                {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
                {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
                {text: 'عملیات', value: 'actions', align: 'center'},
            ],
            detailTableHeaders: [
                {text: 'محصول', value: 'product', align: 'center'},
                {text: 'شماره سریال', value: 'article_number', align: 'center'},
                {text: 'تعداد', value: 'count', align: 'center'},
            ],

            orders: null,

            actions: [
                {
                    icon: 'mdi-receipt-text-check',
                    color: 'primary',
                    emit: 'uploadInvoice',
                    identifier: 'object',
                    tooltip: 'افزودن / ویرایش صورتحساب'
                },
                {
                    icon: 'mdi-note-multiple',
                    color: 'success',
                    emit: 'makeCustomerNote',
                    identifier: 'object',
                    tooltip: 'افزودن / ویرایش یادداشت مشتری'
                },
                {
                    icon: 'mdi-note-multiple',
                    color: 'primary',
                    emit: 'makeAdminNote',
                    identifier: 'object',
                    tooltip: 'افزودن / ویرایش یادداشت پنل'
                },
                {
                    icon: 'mdi-delete',
                    color: 'error',
                    emit: 'delete',
                    identifier: 'id',
                    delete_confirm: true,
                }
            ],

            filters: [],
            searchValues: '',
            allCustomers: []
        }
    },

    mounted() {
        this.getOrders(parseInt(this.$route.query.page ?? "1"))
        this.getAllCustomers()
    },

    methods: {
        search(values) {
            this.$store.dispatch("objectParametersToString", values).then((result) => {
                this.searchValues = result
                this.getOrders()
            })
        },

        getOrders(page = 1) {
            this.$store.dispatch("getPaginatedOrders", page + this.searchValues)
                .then((res) => {
                    this.orders = res.data
                })
        },

        getAllCustomers() {
            this.$store.dispatch("getAllCustomers")
                .then((res) => {
                    this.allCustomers = res.data
                    this.fillFilters()
                })
        },

        fillFilters() {
            this.filters = [
                {
                    type: 'select',
                    name: 'customer_id',
                    label: 'کاربر',
                    select_text: 'name',
                    select_value: 'id',
                    select_items: this.allCustomers,
                },
                {
                    type: 'select',
                    name: 'status',
                    label: 'وضعیت',
                    select_text: 'name',
                    select_value: 'value',
                    select_items: [
                        {name: 'در حال بررسی', value: '0'},
                        {name: 'ارسال صورتحساب', value: '1'},
                        {name: 'لفو شده', value: '2'},
                        {name: 'پایان یافته', value: '3'},
                    ],
                },
                {
                    type: 'date',
                    name: 'date',
                    label: 'تاریخ',
                },
            ]
        },

        deleteOrder(slug) {
            this.$store.dispatch("deleteOrder", slug)
                .then(() => {
                    this.getOrders(this.orders.pagination.current_page)
                })
        },

        statusChanged(item, status) {
            this.$store.dispatch("changeStatus", {
                id: item.id,
                status: status
            })
                .then(() => {
                    this.getOrders(this.orders.pagination.current_page)
                })
        },

        showDetails(item) {
            if (item.order_file_url) {
                let fileLink = document.createElement('a');

                fileLink.href = item.order_file_url;
                fileLink.setAttribute('target', '_blank');
                document.body.appendChild(fileLink);

                fileLink.click();
            } else {
                this.selectedOrder = item
                this.detailsDialog = true
            }
        },

        downloadInvoice(item) {
            if (item.invoice_url) {
                let fileLink = document.createElement('a');

                fileLink.href = item.invoice_url;
                fileLink.setAttribute('target', '_blank');
                document.body.appendChild(fileLink);

                fileLink.click();
            }
        },

        openUploadInvoiceDialog(item) {
            this.uploadInvoiceDialog = true
            this.selectedOrder = item
        },
        closeUploadInvoiceDialog() {
            this.uploadInvoiceDialog = false
            this.selectedOrder = null
            this.invoiceFile = null
        },
        filesReady(file) {
            this.invoiceFile = file
        },
        uploadInvoice() {
            this.$store.dispatch("uploadInvoice", {
                identifier: this.selectedOrder.id,
                image: this.invoiceFile
            })
                .then(() => {
                    this.getOrders(this.orders.pagination.current_page)
                    this.closeUploadInvoiceDialog()
                })
        },

        openWriteCustomerNoteDialog(item) {
            this.writeCustomerNoteDialog = true
            this.selectedOrder = item
            this.customerNote = this.selectedOrder.customer_note
        },
        openWriteAdminNoteDialog(item) {
            this.writeAdminNoteDialog = true
            this.selectedOrder = item
            this.adminNote = this.selectedOrder.admin_note
        },
        closeWriteCustomerNoteDialog() {
            this.writeCustomerNoteDialog = false
            this.selectedOrder = null
        },
        closeWriteAdminNoteDialog() {
            this.writeAdminNoteDialog = false
            this.selectedOrder = null
        },
        updateCustomerNote() {
            this.$store.dispatch("updateCustomerNote", {
                identifier: this.selectedOrder.id,
                note: this.customerNote
            })
                .then(() => {
                    this.getOrders(this.orders.pagination.current_page)
                    this.closeWriteCustomerNoteDialog()
                })
        },
        updateAdminNote() {
            this.$store.dispatch("updateAdminNote", {
                identifier: this.selectedOrder.id,
                note: this.adminNote
            })
                .then(() => {
                    this.getOrders(this.orders.pagination.current_page)
                    this.closeWriteAdminNoteDialog()
                })
        },
    }
}
</script>

<style scoped>
.background-table {
    background-color: #393E46;
}
</style>